import React, { useRef, useState, useLayoutEffect, useEffect, useCallback } from 'react'
import { useSpring, animated } from '@react-spring/web'

export default function AnimatedBookDescription({ className = '', children }) {
  const measureRef = useRef(null)
  const [contentHeight, setContentHeight] = useState(null)

  const updateHeight = useCallback(() => {
    const el = measureRef.current
    if (!el) return
    const next = el.getBoundingClientRect().height
    // Ignore empty frames during exitBeforeEnter handoff
    if (next > 0) setContentHeight(next)
  }, [])

  useLayoutEffect(() => {
    updateHeight()
  })

  useEffect(() => {
    const el = measureRef.current
    if (!el || typeof ResizeObserver === 'undefined') return undefined
    const ro = new ResizeObserver(() => updateHeight())
    ro.observe(el)
    return () => ro.disconnect()
  }, [updateHeight])

  const { height } = useSpring({
    height: contentHeight ?? 0,
    immediate: contentHeight === null,
    config: { tension: 350, friction: 50 },
  })

  return (
    <animated.div
      className={className}
      style={{
        height: contentHeight === null ? 'auto' : height,
      }}
    >
      <div className="book-description-measure" ref={measureRef}>
        {children}
      </div>
    </animated.div>
  )
}
